import { useDebounce, useForm } from '@agrotoken-tech/ui';
import { useState } from 'react';

export const useTableFilters = <T extends string>() => {
  const [selectedStatuses, setSelectedStatuses] = useState<T[]>([]);
  const formMethods = useForm({ defaultValues: { search: '' } });

  const { watch, setValue } = formMethods;
  const search = watch('search');
  const debouncedSearch = useDebounce(search, 300);
  const debouncedStatuses = useDebounce(selectedStatuses, 300);

  const onFiltersReset = () => {
    setValue('search', '');
    setSelectedStatuses([]);
  };

  return {
    formMethods,
    debouncedSearch,
    debouncedStatuses,
    selectedStatuses,
    setSelectedStatuses,
    onFiltersReset,
  };
};

export default useTableFilters;
